export default __webpack_public_path__ + "static/media/Group 10666.ba19208a.svg";